


































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import videojs from 'video.js'

@Component({})
export default class VideoList extends Vue {
	@Prop()
	private videoList!: any
	@Prop()
	private type!: any

	@Prop({
		default: () => ({
			width: 880,
			height: 495,
			controls: true,
			autoplay: false,
			preload: 'auto',
		}),
	})
	private options!: Object

	private player: any = null
	private watching = false
	private currentVideo: any = ''

	private get list() {
		if (this.type) {
			return this.videoList.filter((item: any) => item.type === this.type)
		} else {
			return this.videoList.filter((item: any) => !item.type)
		}
	}

	@Watch('currentVideo')
	private onVideoChange() {
		this.player.src({ type: 'video/mp4', src: this.currentVideo.fileUrl })
	}

	private playVideo(videoObj: any) {
		this.watching = true
		if (this.currentVideo.fileUrl !== videoObj.fileUrl) {
			this.currentVideo = videoObj
		}
	}

	private onClickModal(e: Event) {
		if (e.target === this.$refs.customModal) {
			this.watching = false
		}
	}

	private closeModal() {
		this.watching = false
		this.player.pause()
	}

	private mounted() {
		// Do not use both data-setup and an options object.
		this.player = videojs(this.$refs.myPlayer, this.options)
	}

	private beforeDestroy() {
		if (this.player) {
			this.player.dispose()
		}
	}
}
